import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { BranchLovComponent } from 'src/app/assabil-admin/components/control-tables/branch/branch-lov/branch-lov.component';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Field } from 'src/app/tools/models/dtos/field';
import { RoleLovComponent } from 'src/app/assabil-admin/components/master-data/role/role-lov/role-lov.component';
import { PersonLovComponent } from 'src/app/assabil-admin/components/master-data/person/person-lov/person-lov.component';
import { AssetShipmentService } from '../../services/asset-shimpnent.service';
import { AssetShipment } from '../../models/entities/asset-shipment';
import { AssetShipmentPipe } from '../../pipes/asset-shipment-pipe';


@Component({
    selector: 'asset-shipment-list',
    templateUrl: './asset-shipment-list.component.html',
    styleUrls: ['./asset-shipment-list.component.scss']
})


export class AssetShipmentListComponent extends BasePage2<AssetShipment> {

    assetShipmentCode : string;
    branch            : Branch;
    startDate         : Date;
    endDate           : Date;
    pl_newly_created  : boolean = true;
    pl_shipped        : boolean = true;
    pl_closed         : boolean = true;
       
    
    branchLovComponent = BranchLovComponent;
    
    assetShipments    : AssetShipment[] = [];

    assetAssignmentsColumns   : [];
    assetShipmentAssetsColumns: [];

    constructor(
    protected assetShipmentService  : AssetShipmentService,
    protected toastr                : ToastrService,
    protected router                : Router,
    protected baseService           : BaseService,
    public    leanUtilsService      : LeanUtilsService, 
    protected location              : Location,
    protected activatedRoute        : ActivatedRoute) {
      super(toastr, router, baseService, leanUtilsService, location);
      this.entityName = 'assetShipment';
    }


//--------------------------------------------------------------------------------------------------------
ngOnInit() {
  super.ngOnInit();
    this.baseService.fieldsGet("assetShipmentAssetAssignment").then(result => {
      this.assetAssignmentsColumns = result.listFields;
    });
    this.baseService.fieldsGet("assetShipmentAsset").then(result => {
      this.assetShipmentAssetsColumns = result.listFields;
    });
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
getRows(): AssetShipment[] {
    return this.assetShipments;
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
newAssetShipment(){
  let assetShipment : AssetShipment = new AssetShipment();
  assetShipment.theDate   = new Date();
  assetShipment.inserted  = true;
  assetShipment.edit      = true;
  this.selectedRow        = assetShipment;
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
loadData() {
 
  let branchCode        : string = null;
  if (this.branch) branchCode = this.branch.branchCode;

  let booleans        : boolean[] = [];
  booleans.push(this.pl_newly_created  );
  booleans.push(this.pl_shipped        );
  booleans.push(this.pl_closed         );

  this.assetShipmentService.assetShipmentsGet(
    this.assetShipmentCode,
    branchCode      ,
    booleans        ,
    this.startDate       ,
    this.endDate         ).then(result => {
      this.assetShipments = result;
  });
}
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
selectRow(assetShipment : AssetShipment){
  this.assetShipmentService.assetShipmentGet(assetShipment.assetShipmentCode).then(assetShipment => {
      this.selectedRow = assetShipment;
  });
}
//--------------------------------------------------------------------------------------------------------


assetShipmentPipe : AssetShipmentPipe = new AssetShipmentPipe();
//--------------------------------------------------------------------------------------------------------
enrichField(field : Field){  

  if (field.prop == 'progressLevel')      { field.pipe = this.assetShipmentPipe; }
  
  if (field.prop == 'branch')             { field.modal = BranchLovComponent;  field.subProp = 'name';}
  if (field.prop == 'role')               { field.modal = RoleLovComponent;    field.subProp = 'name';}
  if (field.prop == 'person')             { field.modal = PersonLovComponent;  field.subProp = 'name';}

  if (field.prop == 'person')             { field.modal = PersonLovComponent;  field.subProp = 'name';}
  if (field.prop == 'expeditionPerson')   { field.modal = PersonLovComponent;  field.subProp = 'name';}
  if (field.prop == 'closingPerson')      { field.modal = PersonLovComponent;  field.subProp = 'name';}
}
//--------------------------------------------------------------------------------------------------------

}
